import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

//components
import logo from "../../../images/bound_bleu_logo.png" 

const Verification = ({auth}) => {

    if (auth?.emailVerified) return <Redirect to='/' />

    return (
        <div
        style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#F9FAFB',
            height: '100vh'
        }}
        >  
            <div className="bg-white shadow sm:rounded-lg">
                <div className="px-4 py-5 sm:p-6">
                    <img src={logo} style={{width: 85, marginBottom: 20}} alt='logo'/>
                    <div className="mt-2 max-w-xl text-sm text-gray-500">
                    <p> 
                    We have sent you an email with a link to verify your email address.
                    <br /><br />
                    Please check your email to verify and sign in to Bound. Please check your spam folder as well.
                    <br /><br />
                    Once verified, refresh the page and you should be signed in :).
                    <br /> <br />
                    Thanks,<br />
                    Your Bound App Team 
                    </p>
                    </div>
                </div>
            </div>  
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        profile: state.firebase.profile,
    }
}
  
export default connect(mapStateToProps, null)(Verification)
  
